export const MAP_LABELS_ROOT = {

    maps: 'Карти',
    geoZones: 'Гео зони',
    trackAdvanced: 'Трек ТЗ',
    autoTracking: 'Авто стеження',
    autoTrackingGroup: 'Авто стеження групи',
    autoTrackingObject: 'Авто стеження за ТЗ',
    trackAdvancedGroup: 'Трек групи ТЗ',
    areaSearch: 'Пошук',
    sectionMap: 'Карта',
    back: 'Назад',
    areaSearchDescription: 'Які ТЗ були в намальованій зоні',
    geoZonesDescription: 'Перегляд і редагування геозон',
    trackAdvancedDescription: 'Маршрут одного ТЗ за період',
    autoTrackingDescription: 'Стежити за ТЗ наживо',
    trackAdvancedGroupDescription: 'Маршрути кількох ТЗ за період',
    autoTrackingGroupDescription: 'Стежити за групою ТЗ наживо',

}